module.exports = __webpack_public_path__ + "img/logo_pinx_white.5535f472.png";